import Action from 'actions';
import {Simplex as BaseSimplex} from 'services/sports/default/simplex';

export default class SimplexClassic extends BaseSimplex {
    playerPositionStacking() {
        const {
            playerPositionStacking: stacking,
        } = Action.getState();

        return this.exec('keyPlayerStacking', {
            isOverlapPrimaryAndSecondaryStacksAllowed: stacking.isOverlapPrimaryAndSecondaryStacksAllowed(),
        });
    }

    subjectToPermanent() {
        const constraints = {
            salary: this.exec('salary', {}, []),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, []),
            projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {}, []),
            teams: this.exec('team', {}, []),
            limitPositions: this.exec('limitPositions', {}, []),
            games: this.exec('games', {}, []),
            // stacks: this.exec('stacks', {}, []),
            teamNameStacking: this.exec('teamNameStacking', {}, []),
            keyPlayerStacking: this.exec('playerPositionStacking', {}, []),
            passReceiver: this.exec('passReceiver', {}, []),
            projectionBoostRule: this.exec('projectionBoostRule', {}, []),
            bound: this.exec('bound', {}, []),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {}, []),
            createdLineups: this.exec('createdLineups', {}, []),
            exposureMax: this.exec('exposureMax', {}, []),
            exposureMin: this.exec('exposureMin', {}, []),
            flexExposureMax: this.exec('flexMaxExposure', {}, []),
            correlationStackingPrimaryRule: this.exec('correlationStackingPrimaryRule', {}, []),
            correlationStackingSecondaryRule: this.exec('correlationStackingSecondaryRule', {}, []),
            correlationStackingUniversalRule: this.exec('correlationStackingUniversalRule', {}, []),
            correlationStackingRestrictedPlayers: this.exec('correlationStackingRestrictedPlayers', {}, []),
            keyPlayerStackingComboExpMax: this.exec('keyPlayerStackingComboExpMax', {}, []),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, []),
        };

        return {...constraints};
    }
}
